module.exports = __webpack_public_path__ + "static/media/capy_page_area01_img_en@2x.88d57660.png";